var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.78516 11.5693H7.50016C6.35516 11.5693 5.78516 10.9993 5.78516 9.85434V6.28434C5.78516 5.13934 6.35516 4.56934 7.50016 4.56934H9.78516C10.9302 4.56934 11.5002 5.13934 11.5002 6.28434V9.85434C11.5002 10.9993 10.9302 11.5693 9.78516 11.5693Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.215 3.28434V3.95434C5.905 4.05934 5.16 4.89934 5.16 6.28434V8.56934H3.215C2.07 8.56934 1.5 7.99934 1.5 6.85434V3.28434C1.5 2.13934 2.07 1.56934 3.215 1.56934H5.5C6.645 1.56934 7.215 2.13934 7.215 3.28434Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56555 7.69391H9.12555V7.25391C9.12555 7.04891 8.95555 6.87891 8.75055 6.87891C8.54555 6.87891 8.37555 7.04891 8.37555 7.25391V7.69391H7.93555C7.73055 7.69391 7.56055 7.86391 7.56055 8.06891C7.56055 8.27391 7.73055 8.44391 7.93555 8.44391H8.37555V8.88391C8.37555 9.08891 8.54555 9.25891 8.75055 9.25891C8.95555 9.25891 9.12555 9.08891 9.12555 8.88391V8.44391H9.56555C9.77055 8.44391 9.94055 8.27391 9.94055 8.06891C9.94055 7.86391 9.77055 7.69391 9.56555 7.69391Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundCard);
export default __webpack_public_path__ + "static/media/FundCard.2f2b3eb9f8b9450c27f2f3c667067b7a.svg";
export { ForwardRef as ReactComponent };